// Optional GA4 (PRD 12.4; org-owned property, Assumption 6). With VITE_GA4_ID
// unset nothing is injected and no request is made to Google.
import { env } from '../config';

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
  }
}

let started = false;

/** Inject /ga-init.js + gtag.js once. Safe to call repeatedly. */
export function initAnalytics(): void {
  const id = env.VITE_GA4_ID;
  if (!id || started || typeof document === 'undefined') return;
  started = true;
  const init = document.createElement('script');
  init.src = '/ga-init.js';
  init.setAttribute('data-ga-id', id);
  document.head.appendChild(init);
  const tag = document.createElement('script');
  tag.async = true;
  tag.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(id)}`;
  document.head.appendChild(tag);
}

/** SPA page_view (called on every route change, including the first render). */
export function trackPageView(path: string): void {
  if (!env.VITE_GA4_ID) return;
  window.gtag?.('event', 'page_view', { page_path: path, page_location: window.location.href, page_title: document.title });
}
